import React from "react";
import { Box, alpha, darken } from "@mui/material";
import { ACCENTS } from "../../../styles/uiConstants";
import useTerms from "../../../hooks/useTerms";

// Muayenesi süren randevunun tonu (takvim kartı, hafta listesi, Genel listesi).
export const IN_EXAM_TONE = ACCENTS.violet;

// Sayfa köküne verilen animasyonlar. `.exam-live` kart halkası, `.exam-live-dot`
// rozet noktası; hareket azaltma tercihinde ikisi de durur.
export const examLiveKeyframesSx = {
  "@keyframes examRing": {
    "0%": { boxShadow: `0 0 0 0 ${alpha(IN_EXAM_TONE, 0.35)}` },
    "70%": { boxShadow: `0 0 0 8px ${alpha(IN_EXAM_TONE, 0)}` },
    "100%": { boxShadow: `0 0 0 0 ${alpha(IN_EXAM_TONE, 0)}` },
  },
  "@keyframes examDot": {
    "0%, 100%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.35, transform: "scale(0.75)" },
  },
  "@media (prefers-reduced-motion: reduce)": {
    "& .exam-live, & .exam-live-dot": { animation: "none !important" },
  },
};

// "Muayenede" canlı rozeti — yanıp sönen nokta + etiket
export function ExamLiveBadge({ compact = false }) {
  const terms = useTerms();
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        flexShrink: 0,
        px: compact ? 0.6 : 0.75,
        py: 0.15,
        borderRadius: 99,
        bgcolor: alpha(IN_EXAM_TONE, 0.12),
        color: darken(IN_EXAM_TONE, 0.35),
        fontSize: compact ? "0.62rem" : "0.68rem",
        fontWeight: 600,
        lineHeight: 1.4,
      }}
    >
      <Box
        className="exam-live-dot"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          bgcolor: IN_EXAM_TONE,
          animation: "examDot 1.4s ease-in-out infinite",
        }}
      />
      {terms.inExam}
    </Box>
  );
}
